import React, { Component } from "react";
import { Button } from "reactstrap";
import axios from "axios";
import config from "./config";

class MailingList extends Component {
  state = {
    lastSpecifications: []
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.lastSpecifications.length > 0) {
      this.setState({ lastSpecifications: nextProps.lastSpecifications });
    }
  }

  downloadMailingList = () => {
    axios
      .post("/api/files/getMailingList")
      .then(function(response) {
        window.location = config.proxy + "/csv/MailingList.csv";
      })
      .catch(function(error) {
        console.log(error);
      });
  };

  render() {
    return (
      <Button color="link" onClick={this.downloadMailingList}>
        הורד רשימת תפוצה
      </Button>
    );
  }
}

export default MailingList;
